export default function install (vue) {
  vue.prototype.$store = {}
}



// WEBPACK FOOTER //
// ./src/store/index.js